export enum AutomaticProcessingStatus {
    Active = 0,
    Paused = 1,
}

export interface AutomaticProcessingStatusNotification {
    automatedStatus: {
        status: AutomaticProcessingStatus;
        userName: string;
    };
}
